import { Button, Col, Form, Row } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from 'react';

import { cssVariables } from '../../styles/cssVariables';
import { pxToNumber } from '../../utils/cssUtils';
import { DateRangePicker } from '../../components/dateRange/DateRangePicker';
import { useLayoutElementsStyles } from '../../components/layout/layoutElements.styles';
import { useInvoiceStyles } from '../../dialogs/invoice/invoice.styles';

export function InvoiceDateRange({
  form,
  onDateRangeSearch,
  accountConfirmed,
}) {
  const [, forceUpdate] = useState({});
  const { styles } = useInvoiceStyles();
  const { styles: layoutStyles } = useLayoutElementsStyles();

  useEffect(() => {
    const currentValues = form.getFieldsValue();
    if (!currentValues.dateStart && !currentValues.dateEnd) {
      form.setFieldsValue({
        dateStart: null,
        dateEnd: null,
      });
    }
  }, [form]);

  if (!form) {
    return null;
  }

  const handleDateChange = () => {
    forceUpdate({});
  };

  const handleGetInvoices = () => {
    if (!accountConfirmed) return;

    const currentValues = form.getFieldsValue();
    const { dateStart: startDate, dateEnd: endDate } = currentValues;

    if (!startDate || !endDate) return;

    form
      .validateFields()
      .then(() => {
        onDateRangeSearch?.(currentValues);
      })
      .catch(errorInfo => {
        console.error('Validation failed:', errorInfo);
      });
  };

  return (
    <div className={classNames(styles.section, styles.content)}>
      <div className={styles.selectionSectionTitle}>
        <Row
          className={layoutStyles.flex1}
          gutter={pxToNumber(cssVariables.spaceNorm2)}
        >
          <Col span={12} className={layoutStyles.flexCol}>
            <FormattedMessage id="reports.dateRange.start" />
          </Col>
          <Col span={12} className={layoutStyles.flexCol}>
            <FormattedMessage id="reports.dateRange.end" />
          </Col>
        </Row>
      </div>
      <div className={styles.selectionSectionBody}>
        <Form.Item name="dateStart" noStyle>
          <span />
        </Form.Item>
        <Form.Item name="dateEnd" noStyle>
          <span />
        </Form.Item>
        <DateRangePicker
          form={form}
          withCustomSelectors
          validRangeYearsBack={1}
          onDateChange={handleDateChange}
        />
        <div className={styles.getInvoicesContainer}>
          <Button
            aria-label="Invoices by date"
            onClick={handleGetInvoices}
            disabled={!accountConfirmed}
          >
            <FormattedMessage id="invoice.find" />
          </Button>
        </div>
      </div>
    </div>
  );
}
